import { Injectable } from '@angular/core';
import { ActiveToast, ToastrConfig, ToastrService } from 'ngx-toastr';
import { UserState } from 'src/app/core/models/i-user-state';
import { ToastrMessageComponent } from 'src/app/shared/components/toastr-message/toastr-message.component';

@Injectable({
  providedIn: 'root',
})
export class UserListToastrService {
  undoString = 'undo';
  activeToast: ActiveToast<any>;

  constructor(protected toastrService: ToastrService) {}

  showUserList(
    title: string,
    userList: UserState[],
    userSaved?: string,
    options?: Partial<ToastrConfig>
  ) {
    if (this.activeToast) {
      this.activeToast.toastRef.componentInstance.userList = userList;
      this.refreshToast();
      return;
    }

    this.activeToast = this.toastrService.show('', title, {
      ...options,
      disableTimeOut: true,
      tapToDismiss: false,
      positionClass: 'toast-bottom-right',
      toastComponent: ToastrMessageComponent,
    });

    if (this.activeToast.toastRef.componentInstance) {
      const instance = this.activeToast.toastRef.componentInstance;
      instance.userList = userList;
      instance.title = title;
      instance.userSaved = userSaved;

      instance.close.subscribe(() => {
        this.clearToastr();
      });
    }
  }

  clearToastr(): void {
    if (this.activeToast) {
      this.activeToast.toastRef.close();
      this.activeToast = null;

      this.refreshToast();
    }
  }

  refreshToast() {
    // SPIKE investigate alternative change detection
    setTimeout(() => {}, 0);
  }
}
